import { render, staticRenderFns } from "./ExtendedRequestsTable.vue?vue&type=template&id=e19213c2&scoped=true"
import script from "./ExtendedRequestsTable.vue?vue&type=script&lang=js"
export * from "./ExtendedRequestsTable.vue?vue&type=script&lang=js"
import style0 from "./ExtendedRequestsTable.vue?vue&type=style&index=0&id=e19213c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e19213c2",
  null
  
)

export default component.exports